import type { ApiFeature } from '@app/constants/ApiTypes/internalEntities'

import { createSelector } from '@app/utils/createSelector'

import { createLoadable, mapThunkSelector } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callInternalApi } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'

import { routingDateSelector } from './routing'

const featuresSlice = createReduxSlice<SliceState<ApiFeature[]>>('internal_features')

export const featuresResultSelector = createSelector([featuresSlice.selector, routingDateSelector], (slice, date) =>
  createLoadable(c => {
    return withCheckedSliceState(c, {
      sliceState: slice,
      slice: featuresSlice,
      date: { date, expiresInMinutes: 30 },
      load: async dispatch => {
        const { getFeatures } = await import('@app/packages/internalApi/actions/features')
        return (await dispatch(callInternalApi(getFeatures()))).data
      },
    })
  })
)

export const obsoleteHiddenEnabledResultSelector = mapThunkSelector(
  featuresResultSelector,
  features => !!features.find(feature => feature.id === 'obsolete_messages_hidden')?.attributes.enabled
)

export const minimumRequestAmountEnabledResultSelector = mapThunkSelector(
  featuresResultSelector,
  features => !!features.find(feature => feature.id === 'minimum_request_amount')?.attributes.enabled
)
